import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { toHash } from 'ajv/dist/compile/util';
import { BehaviorSubject,  Subscription, map } from 'rxjs';
import { FormServices } from 'src/app/services/form.services';
import { HTTPService } from 'src/app/services/http.service';

@Component({
    selector: 'data-transform',
    templateUrl: './data-transform.component.html',
    styleUrls: ['./data-transform.component.scss'],
    standalone: false
})
export class DataTransformComponent implements OnInit {

  @Input()integrationData:any;
  @Input()cfiForm:FormGroup<any>;
  @Input()firstFormGroup:FormGroup<any>;
  @Input()dataFormGroup:FormGroup<any>;
  showOrigem = false;
  conditionSearch = ` EXISTS (SELECT 1 FROM Mktpdiccol c where  c.idinstance  = entityPrincipal.idinstance and c.columnname = 'CODECOMPANY')`;
  usaNewXml:boolean = false;
  hasDetails:boolean = false;
  usaProcedureRetorno = false;
  usaSplit = false;
  usaChild = false;
  showCondition: boolean = false;
  executeStatusError:boolean = false;
  showProcedure: boolean;
  orderDataList:BehaviorSubject<any> = new BehaviorSubject([]);
  procedureList:BehaviorSubject<any> = new BehaviorSubject([]);
  sub1:Subscription;
  sub2:Subscription;
  sub3:Subscription;
  sub4:Subscription;
  expression:object = {};
  showExtendedPath: boolean = true;
  initialized: boolean = false;
  constructor(private fb:FormBuilder,private http:HTTPService, private formServices:FormServices) { }

  ngOnDestroy(){
      if ( this.sub1 != null ){ this.sub1.unsubscribe(); }
      if ( this.sub2 != null ){ this.sub2.unsubscribe(); }
      if ( this.sub3 != null ){ this.sub3.unsubscribe(); }
      if ( this.sub4 != null ){ this.sub4.unsubscribe(); }
  }

  async ngOnInit(): Promise<void> {
      
      this.loadOrderData();
      this.loadProcedures();

      this.firstFormGroup = this.fb.group({
          origem:new FormControl<string|null>('.'),
          type: new FormControl<string|null>(null),
          destino: new FormControl<string|null>(null),
          orderData: new FormControl<number|null>(null),
          origemPath: new FormControl<string|null>(null),
          procedure: new FormControl<string|null>(null),
          hasDetails: new FormControl<boolean|null>(false),
          details:new FormControl<string|null>(null),
          usaNewXml: new FormControl<boolean|null>(false),
      });

      this.dataFormGroup  =  this.fb.group({
        condicaoMaxRows: new FormControl<number|null>(100),
        executeStatusError: new FormControl<boolean|null>(false),
        operacao: new UntypedFormControl(null),
        split: new FormControl<string|null>(null),
        child: new FormControl<string|null>(null),
        condicao:new FormControl<string|null>(null),
      });

      
      if ( this.cfiForm.get("EXPRESSION").value){
          this.expression = JSON.parse(this.cfiForm.get("EXPRESSION").value);
      
          if ( this.expression ){
            if ( this.expression['origem']!=null ){
              if ( this.expression['origem']!='.' ){
                this.showOrigem = true;
              }
            }
            if ( this.expression['destino']!= null ){
              await this.loadInstanceByName(this.expression['destino']).then(sql=>{
                
                if ( sql!= null ){
                  this.expression['destino'] = sql['IDINSTANCE'];
                  this.formServices.refreshFormObject(this.firstFormGroup,this.expression,false);
                  if ( this.expression['data'] ){
                    this.formServices.refreshFormObject(this.dataFormGroup,this.expression['data'],false);
                  }
                }
              });
            }else{
              this.formServices.refreshFormObject(this.firstFormGroup,this.expression,false);
              if ( this.expression['data'] ){
                this.formServices.refreshFormObject(this.dataFormGroup,this.expression['data'],false);
              }
            }
          }
          this.initialized = true;
      }else{
        this.expression = {"origem":"."};
        this.initialized = true;
      }
      
      this.observeChanges();
      
      if ( this.dataFormGroup.get('operacao').value=="INSERIR"){
        this.showCondition = false;
      }else{
        this.showCondition = true;
      }
    
  }

  observeChanges(){
    this.sub3 = this.firstFormGroup.valueChanges.subscribe(data=>{
      if ( this.initialized ){
        this.fieldsExpressionAdjust(data,null);
        this.cfiForm.get('EXPRESSION').setValue(JSON.stringify(this.expression));
      }
      
    });

    this.sub4 = this.dataFormGroup.valueChanges.subscribe(data=>{
      if ( this.initialized ){
        this.fieldsExpressionAdjust(data,'data');
        this.cfiForm.get('EXPRESSION').setValue(JSON.stringify(this.expression));
      }
    });
  }

  fieldsExpressionAdjust(data,key:string){
    
    Object.keys(data).forEach(field=>{
      if ( data[field] ){
        if ( field == 'destino->INSTANCENAME'){
          this.expression['destino'] = data['destino->INSTANCENAME'];
        }else{
          if( key!= null ){
            if ( this.expression[key] == null ){
              this.expression[key] = {};  
            }
            this.expression[key][field] = data[field];
          }else{
            this.expression[field] = data[field];
          } 
        }
      }else{
        if ( field == 'destino->INSTANCENAME'){
              delete this.expression['destino'];
          }else{
            if ( key != null ){
              delete this.expression[key][field];
            }else{
              delete this.expression[field];
            }
          }
      }
  });
  }


  readonly operationCodes =[
    {
      name:'Somente Incluir',
      operation: "INSERIR"
    },
    {
      name:'Somente Alterar',
      operation: "ALTERAR"
    },
    {
      name:'Incluir ou Alterar',
      operation:'INSERIR_ALTERAR'
    }
  ] as const;

  readonly typeObjectCode = [
    {
      name:'Lista de Objetos',
      type: 'array'  
    },
    {
      name:'Objeto',
      type: 'object'
    },
    {
      name:'Objeto Sankhya',
      type:'sankhyaJson'  
    }/*,
    {
      name:'Lista de Objetos ( JSON JayWay )',
      type:'array2'  
    }*/
  ] as const;

  changeOperation(evento:MatSelectChange){
    if ( evento.value == 'INSERIR'){
      this.showCondition = false;
    }else{
      this.showCondition = true;
    }
  }

  changeTipoProc(evento:MatSelectChange){
      if ( evento.value == 'sankhyaJson' ){
          this.firstFormGroup.get('origem').setValue('sql');
          this.firstFormGroup.get('origem').disable();
          this.showExtendedPath = false;
      }else{
        if ( evento.value == 'object' ){
          this.firstFormGroup.get('origemPath').removeValidators(Validators.required);
        }
        this.firstFormGroup.get('origem').setValue('.');
        this.firstFormGroup.get('origem').enable();
        this.showExtendedPath = true;
      }
  }

  onToggleChange(columnName){

      if ( columnName == 'usaProcedureRetorno'){
        if ( this.usaProcedureRetorno){
          this.showProcedure = true;
          let procedureName = this.firstFormGroup.get('procedure').value;
          if ( procedureName != null ){
            this.expression['procedure']=this.expression['procedure'] = procedureName;
          }
        }else{
          this.showProcedure = false;
          this.firstFormGroup.get('procedure').setValue(null);
          delete this.expression['procedure'];
        }
      }

      if ( columnName == 'executeStatusError'){
        this.dataFormGroup.get('executeStatusError').setValue(this.executeStatusError);
      }


      if ( columnName == 'usaChild'){
        setTimeout(()=>{
            this.usaChild = false;
        },0)
        throw new Error('Tipo não implementado.');
      }

      if ( columnName == 'usaSplit'){
        setTimeout(()=>{
          this.usaSplit = false;
        },0)
        throw new Error('Tipo não implementado.');
      }

      if ( columnName == 'hasDetails'){
        setTimeout(()=>{
          this.hasDetails = false;
        },0)
        throw new Error('Tipo não implementado.');
      }
  }

  
  public loadOrderData(){
    
    let ob = new Object();
    ob= {      
      "entityName":"Mktpcfi",
      "condition":`idconf=${this.integrationData.idConf} and execorder <= ${this.integrationData.sequence} and serviceType in ('1','2','15')`
    };

    this.sub1 = this.http.post(ob,"JsonBrokerServices/find", true).subscribe(data=>{
        this.orderDataList.next( data['Mktpcfi']);
    });
    
  }

  public loadProcedures(){
    
    return new Promise((resolve,reject)=>{
      let obinfo = {
        "entityName":"Mktpdbobjects",
        "sql":`SELECT * FROM MKTPDBOBJECTS (nolock) WHERE 0=0 /*CODECOMPANY=${this.integrationData.codeCompany} */ AND TYPE='P' AND STATUS='1' ORDER BY OBJECTNAME`
      }         
          
      this.sub2 = this.http.post(obinfo,'JsonBrokerServices/findnative',false,true,true).subscribe(conInfo=>{
        let info =  conInfo['SQL'];
        this.procedureList.next(info);
        resolve(true);
      });
    });
    
  }

  public loadInstanceByName(instanceName){
    
    return new Promise((resolve,reject)=>{
      let obinfo = {
        "entityName":"Mktpdiccol",
        "sql":`SELECT * FROM MKTPDIC (nolock) WHERE INSTANCENAME='${instanceName}'`
      }         
          
      this.sub2 = this.http.post(obinfo,'JsonBrokerServices/findnative',false,true,true).subscribe(conInfo=>{
        let info =  conInfo['SQL'];
        resolve(info[0]);
      });
    });
    
  }

}
